import { AlertSubscription, UserNotificationFilters } from "generated/graphql";
import { SubscribableApp } from "../types";

/**
 * Formats filters for display
 */
export const formatFilters = (filters?: UserNotificationFilters | null): string => {
    if (!filters) return "No filters";

    const parts: string[] = [];
    if (filters.contactType && filters.contactType.length > 0) {
        parts.push(`Contact: ${filters.contactType.join(", ")}`);
    }
    if (filters.highValueLead) {
        parts.push("High Value");
    }
    if (filters.jobType && filters.jobType.length > 0) {
        parts.push(`Job: ${filters.jobType.join(", ")}`);
    }
    if (filters.urgency && filters.urgency.length > 0) {
        parts.push(`Urgency: ${filters.urgency.join(", ")}`);
    }
    if (filters.serviceType && filters.serviceType.length > 0) {
        parts.push(`Service: ${filters.serviceType.join(", ")}`);
    }

    return parts.length > 0 ? parts.join("; ") : "No filters";
};

/**
 * Formats filters for alert subscriptions
 */
export const formatAlertSubscriptionFilters = (subscription: AlertSubscription): string => {
    return formatFilters(subscription.filters);
};

/**
 * Gets app name by ID from the list of apps
 */
export const getAppName = (appId: string, apps: SubscribableApp[]): string => {
    const app = apps.find((a) => a.appId === appId);
    return app?.name || appId;
};
